import { AUTH_CONFIG } from './auth0-variables';

// Fetches the SSO tenant config from the server (single source of truth in
// MongoDB) and replaces AUTH_CONFIG.ssoConnections in place. ssoRouting.js reads
// AUTH_CONFIG.ssoConnections live on each call, so updating it here is enough —
// no other client code needs to change.
//
// The hardcoded ssoConnections in auth0-variables.js stays as the fallback:
// until this resolves (or if it fails / returns empty), routing uses those
// values, so SSO login keeps working regardless.

let loadPromise = null;

function replaceConnections(next) {
  if (!next || typeof next !== 'object' || Array.isArray(next)) return;
  if (Object.keys(next).length === 0) return; // empty → keep fallback
  for (const key of Object.keys(AUTH_CONFIG.ssoConnections)) {
    delete AUTH_CONFIG.ssoConnections[key];
  }
  Object.assign(AUTH_CONFIG.ssoConnections, next);
}

export function loadSsoConnections() {
  if (loadPromise) return loadPromise;

  loadPromise = fetch('/api/auth/sso-connections', {
    headers: { Accept: 'application/json' },
  })
    .then((res) => (res.ok ? res.json() : null))
    .then((data) => {
      replaceConnections(data && data.ssoConnections);
      return AUTH_CONFIG.ssoConnections;
    })
    .catch((err) => {
      console.warn('[sso-connections] using fallback config:', err && err.message);
      return AUTH_CONFIG.ssoConnections;
    });

  return loadPromise;
}
